const CptName = 'ComNewsSource'
function formatData (node) {
  // console.dir(node);
  return {
    data: {
      source: node.dataset.source,
      url: node.dataset.url
    },
    cpt: CptName
  }
}

export default {
  name: 'news_source',
  formatData
}